import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { midas } from '@resurs/midas'
import { Conditional } from '@resurs/react-utils'
import { Container, Columns, Column, Card } from '@resurs/midas-react'

import style from './login.style'
import { getText } from '../../internal/TextLabels'
import packageJson from '../../../../../package.json'
import { LanguageSelector } from '../../components/common/Language/LanguageSelector'

const LoginUI = ({
  title,
  language,
  noPasswordText,
  noPasswordLink,
  children,
}) => (
  <Container grid960>
    <Columns>
      <Column col12>
        <div
          style={style.pushTop}
          className={[midas.textCenter, midas.mt10].join(' ')}
        >
          <Conditional when={!!language}>
            <LanguageSelector />
          </Conditional>
          <div style={style.hero.logo} />
          <div>
            <h1 style={style.hero.h1}>
              {language ? title : 'Welcome to Merchant Portal'}
            </h1>
          </div>
        </div>
      </Column>
    </Columns>
    <Columns>
      <Column col4 colMd2 colSm0 />
      <Column col4 colMd8 colSm12>
        <Card>{children}</Card>
      </Column>
    </Columns>
    <Conditional when={!!language}>
      <Columns>
        <Column col4 colMd2 colSm0 />
        <Column col4 colMd8 colSm12>
          <Card>
            <span style={{ float: 'left' }}>{noPasswordText}</span>
            &nbsp;
            <div style={{ float: 'left' }}>
              <NavLink data-cy="forgot_link" to="/password/forgot">
                &nbsp;
                {noPasswordLink}
              </NavLink>
            </div>
          </Card>
        </Column>
      </Columns>
    </Conditional>
    <Columns>
      <Column col4 colMd2 colSm0 />
      <Column col4 colMd8 colSm12>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <span style={{ color: '#ddd' }}>
            {getText('version', packageJson.version)}
          </span>
        </div>
      </Column>
    </Columns>
  </Container>
)

LoginUI.propTypes = {
  title: PropTypes.string.isRequired,
  noPasswordText: PropTypes.string.isRequired,
  noPasswordLink: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
  language: PropTypes.string,
}

LoginUI.defaultProps = {
  language: null,
}
export default LoginUI
